<div
  class="textarea-wrapper"
  [class.textarea-wrapper--error]="control.invalid && control.touched"
  [class.textarea-wrapper--disabled]="control.disabled"
>
  <textarea
    class="textarea-wrapper__field"
    [id]="uniqueId"
    [formControl]="control"
    placeholder=" "
    rows="4"
  ></textarea>

  <label class="textarea-wrapper__label" [for]="uniqueId">
    {{ field.label }}
    @if (field.required) {
      <span class="required-asterisk" aria-hidden="true"> *</span>
    }
  </label>
</div>
